<template>
    <div class="col-lg-12 col-md-12 col-sm-12 col-xs-12">
        <RecommendedDriver :isPublic="false" :prop-recommended-query-params=this.typeNumberQueryParam :prop-product-name=null></RecommendedDriver>
    </div>
</template>

<script>
    import RecommendedDriver from "../../components/parametric-search/RecommendedDriver"

    export default {
        name: "MyParametricDriver",
        components: {
            RecommendedDriver
        },
        computed: {
            typeNumberQueryParam() {
                return this.$route.query.typeNumber;
            }
        }
    }
</script>
